import { Controller } from 'stimulus';

const AVAILABLE_SOON_LABEL = 'Available Soon';

export default class extends Controller {
  static targets = ['dateField'];

  dateFieldTarget!: HTMLElement;

  connect() {
    this.element.addEventListener('change', (event) => {
      const target = event.target as HTMLElement;
      if (
        target.matches('input[name="reuse_availability[]"]') ||
        target.matches('select[name="reuse_availability[]"]')
      ) {
        this.toggleDateField();
      }
    });
    this.toggleDateField();
  }

  toggleDateField() {
    const checked = this.element.querySelectorAll<HTMLInputElement>(
      'input[name="reuse_availability[]"]:checked'
    );
    const selects = this.element.querySelectorAll<HTMLSelectElement>(
      'select[name="reuse_availability[]"]'
    );
    const selectedFromSelect = Array.from(selects).flatMap((select) =>
      Array.from(select.selectedOptions).map((option) => option.value)
    );
    const values = [
      ...Array.from(checked).map((input) => input.value),
      ...selectedFromSelect,
    ];
    const show = values.includes(AVAILABLE_SOON_LABEL);
    this.dateFieldTarget.style.display = show ? '' : 'none';

    const input = this.dateFieldTarget.querySelector<HTMLInputElement>('input');
    if (!input) return;

    input.disabled = !show;
    if (!show) {
      input.value = '';
    }
  }
}
